<template>
   <div class="userinfotitle">
        {{msg}}
    </div>
</template>

<script>
export default {
    props:['msg']
}
</script>

<style>
    .userinfoshow{
        width: 909px;
        margin: 0 auto;
        margin-top: 28px;
    
    }
    .userinfotitle{
    color:#2655ae;
    font-size:18px;
    padding-bottom: 22px;
    border-bottom: 1px solid #fdd889;
    margin-bottom: 14px;
    }
</style>


// WEBPACK FOOTER //
// src/components/user/UserTitle.vue